import React, { Fragment } from 'react';
import { SlashLink as Link } from './SlashLink';
import { splitInlineLinks } from '../utils/inlineLinks';

/** Visible FAQ entries from src/data/seoFaqs.js (the same text feeds FAQPage JSON-LD). */
export default function SeoFaqItems({ faqs }) {
  return faqs.map(({ q, a }) => (
    <article className="faq-item" key={q}>
      <h3>{q}</h3>
      <p>
        {splitInlineLinks(a).map((part, i) =>
          part.type === 'link' ? (
            <Link key={i} to={part.href}>{part.label}</Link>
          ) : (
            <Fragment key={i}>{part.value}</Fragment>
          )
        )}
      </p>
    </article>
  ));
}
